import(/* webpackMode: "eager" */ "/vercel/path0/apps/sf-granditude-site/src/app/(other_pages)/pricing/components/PricingPageClient.tsx")